import React 			from 'react';

import Icon				from './Icon';

import img_save			from '../../images/icon/save.svg';


export function IconModalSave() {
	return (
		<Icon
			size={40}
			iconBorder
			iconSize={18}
			borderSize={8}
			icon={img_save}
			type={'warning'}
		/>
	);
}